import { Box, Typography } from "@mui/material";
import React from "react";
import { useRef } from "react";
import Navbar from "../components/Navbar.jsx";
import Banner from "../components/img/Banner/OurCourses.png";
import Courses from "../components/sections/Courses.jsx";
import Testimonials from "../components/home-compo/Testimonials.jsx";
import Footer from "../components/common-components/Footer.jsx";
import "../styles/pages-style/Course.css";

function Course() {
  const testimonialsRef = useRef(null);

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box className="root-container" sx={{ overflowX: "hidden" }}>
      <Navbar scrollToTestimonials={scrollToTestimonials} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "308px", sm: "100%", md: "1319px" }, // Adjust width for tablets
            height: { xs: "315px", sm: "auto", md: "339px" }, // Dynamic height for tablets
            mt: "14vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            overflow: "hidden", // Prevents image overflow
            "@media (max-width: 1024px) and (min-width: 768px)": {
              overflow: "visible", // Show full image in tablet view
            },
          }}
        >
          <img
            src={Banner}
            className="responsive-banner"
            alt="Courses Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover", // Default cropping behavior
              objectPosition: "center", // Keeps focus on the center
              borderRadius: "8px",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              padding: "5px 10px",
              borderRadius: "5px",
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "28px",
                color: "#FFFFFF",
                fontFamily: "'Kumbh Sans', sans-serif",
              }}
            >
              Courses
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",
                  color: "#FFFFFF",
                  fontFamily: "'Kumbh Sans', sans-serif",
                  pr: "5px",
                }}
              >
                Home
              </Typography>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",
                  color: "#FFCC25",
                  fontFamily: "'Kumbh Sans', sans-serif",
                }}
              >
                {" "}
                / Courses
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box className="main-container">
          <Courses />
        </Box>

        <Box ref={testimonialsRef} className="testimonials-container-main">
          <Testimonials />
        </Box>
        <Box sx={{ height: "6vh" }}></Box>
      </Box>
      <Box className="footer-class" sx={{ width: "98.3%" }}>
        <Footer scrollToTestimonials={scrollToTestimonials} />
      </Box>
    </Box>
  );
}

export default Course;
